const firebaseConfig = {
  apiKey: "AIzaSyA_1Qo_I1UYzW-KH4pI4bMUcyJRo7rD-lA",
  authDomain: "fir-authentication-f4897.firebaseapp.com",
  projectId: "fir-authentication-f4897",
  storageBucket: "fir-authentication-f4897.appspot.com",
  messagingSenderId: "92605586204",
  appId: "1:92605586204:web:6fe770277e4046f26878d9",
};

export default firebaseConfig;
